import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { FacebookBlockAttsInterface } from '~/types/AppData/Blocks/FacebookBlockInterface';
import Embed from '~/components/Shared/Embeds/Embed';

export default component$((value: FacebookBlockAttsInterface): JSX.Element => {
  return (
    <Embed
      embed={`
        <div id="fb-root"></div>
        <div class="fb-post" data-href="${value.originalEmbedUrl}" data-width="500"></div>
      `}
      type='facebook'
      isLoadedProp='mmFacebookLoaded'
      loadScript='https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0'
    />
  );
});
